import React, { useEffect, useState, useMemo } from 'react';
import { Button, Col, Container, Form, Pagination, Row, Spinner } from 'react-bootstrap';

import { useLocation, Link } from 'react-router-dom'
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';

import api from '../../api/api.js';
import SchemeSidebarFilter from './SchemeSidebarFilter.js';

import SchemeDetails from './SchemeDetails.js'; // New Details component
import { pcTableDisplayColumns, parentColumnGroups, parentColumns, parentDetailsColumns, childColumns } from './WatchlistPCtableColumns.js';
import 'bootstrap/dist/css/bootstrap.min.css'; // Make sure Bootstrap CSS is imported
import '../custom_styles.css';

// import SchemeTable from './scheme_table.js';
import ParentChildTable from '../../components/AnaRBcompnts/PCtableTmpl.js';
import Switch from '../../components/Switch';
import DeleteConfirmationModal from '../../components/ConfirmationModal';
import SelectConfirmationModal from '../../components/ConfirmationModal';
import ParentSchemeDeleteConfirmation from '../../components/ConfirmationModal';
import AppFooter from "../../components/AppFooter";


// import WatchListModal from '../../components/WatchListModal.js';

export default function WatchlistSchemeSubstitute({
  urlParams,
  apiURL=null,
  topX = null,
  filters = null,
  schemeListTitle="Watchlist Scheme Substitutes",
}) {

    // Flags
    const TOPX_CNT=20;
    const [noUserManagedSort, setNoUserManagedSort]=useState(true);

    const [watchlistSchemesAndSubstitutes, setWatchlistSchemesAndSubstitutes] = useState([]);
    
    const location = useLocation();

    // const {baseScheme, categoryName, typeName, routerURL, urlParams, isAddToWatchlistApplicableState } = location.state;
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showToastMsg, setShowToastMsg] = useState(false);

    // Filter States
    const [displayAll, setDisplayAll] = useState(false);
    const [sortConfig, setSortConfig] = useState({
        field: null,
        direction: "asc"
    });

    // For Details
    const [selectedSchemeCode, setSelectedSchemeCode] = useState(null);
    const [selectedScheme, setSelectedScheme] = useState(null);
    const [detailsLoading, setDetailsLoading] = useState(false);
    const [addToWatchListMessage, setAddToWatchListMessage] = useState("");

    const [selectTarget, setSelectTarget] = useState(null);
    const [deleteTarget, setDeleteTarget] = useState(null);
    const [deletePtarget, setDeletePtarget] = useState(null);
    const [schemeSubstituteMessage, setSchemeSubstituteMessage] = useState("");
    const [schemeListChanged, setSchemeListChanged]=useState(false);

    useEffect(() => {
        setLoading(true);
        console.log(urlParams? "URL Params is - " + urlParams?.watchlistName : "URL Params is null")
        api.get('/get-watchlist-scheme-substitute', { params: urlParams})
          .then(res => { /** console.log(res.data); **/ 
            setWatchlistSchemesAndSubstitutes(res.data.watchlistSchemesAndSubstitutes)
          })
          .catch(err => err.data?.error ? setError(err.data.error) : setError('Failed to load schemes.'))
          .finally(() => {
            setLoading(false);
            setSchemeListChanged(false);
          });
    }, [schemeListChanged]);

  function renderParentDetails(parent) {
    return (
      <div>
        <h4>{parent.scheme_name}</h4>
        <hr />
        <p>
          NAV base value Date : {parent.nav_base_value_date}
        </p>
        <p>
          Last Known Actual NAV : {parent.last_known_actual_nav}
        </p>
        <p>
          Last Known Actual NAV Date : {parent.last_known_actual_nav_date}
        </p>
        <p>
          % Change in 90 Days : {parent.percent_change_in_90_days}
        </p>
        <p>
          Annualized returns in last 5 years : {parent.annualized_returns_in_last_5_year}
        </p>
      </div>
    );
  }

  function renderChildDetails(child) {
    return (
      <div>
        <h4>{child.scheme_name}</h4>
        <hr />
        <p>
          NAV base value Date : {child.nav_base_value_date}
        </p>
        <p>
          Last Known Actual NAV : {child.last_known_actual_nav}
        </p>
        <p>
          Last Known Actual NAV Date : {child.last_known_actual_nav_date}
        </p>
        <p>
          % Change in 90 Days : {child.percent_change_in_90_days}
        </p>
        <p>
          Annualized returns in last 5 years : {child.annualized_returns_in_last_5_year}
        </p>
      </div>
    );
  }

  const getSelectConfirmationMsg = (watchlistName) => {
      return (
      <span>
          Are you sure you want to Select scheme
          {" from watchlist '" } <i className="text-primary">{watchlistName}</i>  { "'" }
      </span>
      )
  }

  const handleSelectSchemeSubstitute = async (e, targetPayload) => {
    e.preventDefault();
    const payload = {
      watchlistName: targetPayload.watchlistName,
      watchlistScheme_id: targetPayload.parentSchemeKey,
      substituteScheme_ids: [targetPayload.childSchemeKey]
    };

    setSchemeSubstituteMessage("");
    setSelectTarget(null);
    try {
      const res = await api.post('/select-watchlist-scheme-substitute', payload); // JSON.stringify([selectedScheme.id]));
      if (res.status === 200) {
        setSchemeSubstituteMessage(res.data.message || 'Successfully Substituted Scheme');
        setSchemeListChanged(true);
      } else if (res.status >= 400) {
        setSchemeSubstituteMessage(res.data.error || 'Scheme not Substituted');
      }
      setShowToastMsg(true);
      return res.data
    } catch (err) {
      setSchemeSubstituteMessage(err.response?.data?.message || err.response?.data?.error || 'Could not Substitute Scheme');
      setShowToastMsg(true);
    }
  };

  const confirmSelectFromWatchList = ((e, context, parentKey, childKey) => {
      const payload = {
        watchlistName: context,
        parentSchemeKey: parentKey,
        childSchemeKey: childKey,
      };
      setSelectTarget(payload);
  });

  const getDeleteConfirmationMsg = (watchlistName) => {
      return (
      <span>
          Are you sure you want to Delete scheme
          {" from watchlist '" } <i className="text-primary">{watchlistName}</i>  { "'" }
      </span>
      )
  }
  
  const handleDeleteSchemeSubstitute = async (e, targetPayload) => {
    e.preventDefault();
    const payload = {
      watchlistName: targetPayload.watchlistName,
      watchlistScheme_id: targetPayload.parentSchemeKey,
      substituteScheme_ids: [targetPayload.childSchemeKey]
    };
    setSchemeSubstituteMessage("");
    setDeleteTarget(null);
    try {
      const res = await api.post('/delete-watchlist-scheme-substitute', payload);
      if (res.status === 200) {
        setSchemeSubstituteMessage(res.data.message || 'Successfully Deleted Scheme');
        setSchemeListChanged(true);
      } else if (res.status >= 400) {
        setSchemeSubstituteMessage(res.data.error || 'Scheme not deleted');
      }
      setShowToastMsg(true);
      return res.data
    } catch (err) {
      setSchemeSubstituteMessage(err.response?.data?.message || err.response?.data?.error || 'Could not delete Scheme');
      setShowToastMsg(true);
    }
  };

  const confirmDeleteFromWatchList = ((e, context, parentKey, childKey) => {
      const payload = {
        watchlistName: context,
        parentSchemeKey: parentKey,
        childSchemeKey: childKey,
      };
      setDeleteTarget(payload);
  });

  const getPdeleteConfirmationMsg = (watchlistName) => {
      return (
      <span>
          Are you sure you want to Delete scheme
          {" from watchlist '" } <i className="text-primary">{watchlistName}</i>  { "'" }
      </span>
      )
  }
  
  const handleParentSchemeDelete = async (e, targetPayload) => {
    e.preventDefault();
    const payload = {
      watchlistName: targetPayload.watchlistName,
      selectedSchemes: [targetPayload.parentSchemeKey],
    };
    setSchemeSubstituteMessage("");
    setDeletePtarget(null);
    try {
      const res = await api.post('/delete-scheme-from-watchlist', payload);
      if (res.status === 200) {
        setSchemeSubstituteMessage(res.data.message || 'Successfully Deleted Parent Scheme');
        setSchemeListChanged(true);
      } else if (res.status >= 400) {
        setSchemeSubstituteMessage(res.data.error || 'Parent Scheme not deleted');
      }
      setShowToastMsg(true);
      return res.data
    } catch (err) {
      setSchemeSubstituteMessage(err.response?.data?.message || err.response?.data?.error || 'Could not delete Parent Scheme');
      setShowToastMsg(true);
    }
  };

  const confirmParentSchemeDelete= ((e, context, parentKey) => {
      const payload = {
        watchlistName: context,
        parentSchemeKey: parentKey
      };
      setDeletePtarget(payload);
  });

  const sortedData = useMemo(() => {
      const items = [...watchlistSchemesAndSubstitutes];

      if (!sortConfig.field) return items;

      items.sort((a, b) => {
          const av = a.ParentWatchlistScheme[sortConfig.field];
          const bv = b.ParentWatchlistScheme[sortConfig.field];

          if (av == null && bv == null) return 0;
          if (av == null) return sortConfig.direction === "asc" ? -1 : 1;
          if (bv == null) return sortConfig.direction === "asc" ? 1 : -1;

          let result;

          if (
              typeof av === "number" &&
              typeof bv === "number"
          ) {
              result = av - bv;
          } else {
              result = String(av).localeCompare(
                  String(bv),
                  undefined,
                  {
                      numeric: true,
                      sensitivity: "base"
                  }
              );
          }

          return sortConfig.direction === "asc"
              ? result
              : -result;
      });

      return items;
  }, [watchlistSchemesAndSubstitutes, sortConfig]);

  const handleSort = (field) => {
      setSortConfig((prev) => ({
          field: field,
          direction:
              prev.field === field &&
              prev.direction === "asc"
                  ? "desc"
                  : "asc"
      }));
  };
//  container-fluid mt-1
  return (
    <>
      <div className="app-shell">
          {loading ? (
              <div 
                className="d-flex justify-content-center align-items-center" 
                style={{ height: '100vh', width: '100vw' }}
              >
                <Spinner animation="border" variant="primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
          ) : (
            <> 
              <Row className="align-items-center">
                  <Col xs={12} className="d-flex justify-content-center pt-1">
                    <h4>
                      <span class="fst-italic">{schemeListTitle}</span>
                      <span style={{fontSize:'0.90rem'}}>
                      </span>
                    </h4>                      
                  </Col>
              </Row>
              <Row>
                  <div className="app-content">
                      <Container fluid className="py-1">
                        <ParentChildTable
                              data={sortedData}
                              parentColumns={parentColumns}
                              childColumns={childColumns}
                              parentKey="scheme_info_id"
                              childKey="scheme_info_id"
                              childrenField="watchlistSchemeSubstitutes"

                              parentNameField="scheme_name"
                              childNameField="scheme_name"

                              renderParentDetails={renderParentDetails}
                              renderChildDetails={renderChildDetails}
                              handleSort={handleSort}
                              sortConfig={sortConfig}

                              deleteParentScheme={confirmParentSchemeDelete}
                              selectSubstituteChild={confirmSelectFromWatchList}
                              deleteSubstituteChild={confirmDeleteFromWatchList}
                              context={urlParams.watchlistName}
                        />
                      </Container>
                  </div>
              </Row>
              <Row>
                <ToastContainer position="middle-center" className="p-3">
                  <Toast onClose={() => {setError(""); setShowToastMsg(false); return true;}} 
                                            show={showToastMsg} delay={5000} autohide>
                    <Toast.Header>
                        <strong className="me-auto">Scheme Susbstitution/Deletion  Message</strong>
                        <small>*******</small>
                    </Toast.Header>
                    <Toast.Body>{schemeSubstituteMessage}</Toast.Body>
                   </Toast>
                </ToastContainer>
                <SelectConfirmationModal
                    target={selectTarget}  confirmationName={"Select Scheme"}
                    confirmationTitle={" Scheme Selection"}
                    onConfirmFinish={() => setSelectTarget(null)}
                    confirmHandle={handleSelectSchemeSubstitute}
                    confirmationQuestion={getSelectConfirmationMsg}
                    param1={urlParams.watchlistName}
                />
                <DeleteConfirmationModal
                    target={deleteTarget} confirmationName={"Delete Scheme"}
                    confirmationTitle={" Scheme Delete"}
                    onConfirmFinish={() => setDeleteTarget(null)}
                    confirmHandle={handleDeleteSchemeSubstitute}
                    confirmationQuestion={getDeleteConfirmationMsg}
                    param1={urlParams.watchlistName}
                />
                <ParentSchemeDeleteConfirmation
                    target={deletePtarget} confirmationName={"Delete Scheme"}
                    confirmationTitle={" Parent and Substitute Scheme Delete"}
                    onConfirmFinish={() => setDeletePtarget(null)}
                    confirmHandle={handleParentSchemeDelete}
                    confirmationQuestion={getPdeleteConfirmationMsg}
                    param1={urlParams.watchlistName}
                />
              </Row>
              <Row className="mt-3">
                  <AppFooter
                      brand="AbhisaraNa (अभिसरण)"
                      version="v0.79.21"
                      main_disclaimer_msg="MF Scheme's NAV, Returns, NAV Predictions and Analytics is based on available data and may be subject to revision. Past performance does not guarantee future results."
                      disclaimer_info="More about Risks in Mutual Fund - https://www.amfiindia.com/investor/knowledge-center-info?zoneName=riskInMutualFunds."
                  />
              </Row>
            </>
          )}
      </div>
    </>
  );
}

